"use client";
import React from 'react';
import dynamic from 'next/dynamic';
import { isProduction } from '@/utils/constants';
import useEnvVariable from '@/hooks/useEnvVariable';

const NewRelicClient = dynamic(() => import('./NewRelicClient'), { ssr: false });

export default function NewRelic() {
  const { newrelicAppId } = useEnvVariable();

  if (!isProduction || !newrelicAppId) return null;

  return <NewRelicClient appId={newrelicAppId} />;
}
